"use client";

type NeoDocumentProps = {
  data?: any[];
  onClick?: (data: any[]) => void;
};

export const NeoDocument = ({data = [], onClick}: NeoDocumentProps) => {
  const count = data.length;

  return (
    <div className="mt-2 flex items-center gap-2">
      <span className="inline-flex items-center justify-center rounded-md bg-yellow-100 px-3 py-1 text-xs font-semibold text-yellow-600">
        {count}
      </span>
      <button
        type="button"
        onClick={() => onClick?.(data)}
        className="rounded hover:bg-yellow-50"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="text-yellow-500"
        >
          <path d="M21.44 11.05 12 20.5a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66L9.17 18.17a2 2 0 1 1-2.83-2.83l8.49-8.49" />
        </svg>
      </button>
    </div>
  );
};
